import classNames from 'classnames';
import { PropsWithChildren, PropsWithClassName } from 'lib-shared-types-utils';

import { AnalyticsSidenavSection as AnalyticsSidenavSectionT } from '../../analyticsSidenav.types';

import styles from './analyticsSidenavSection.module.scss';

type AnalyticsSidenavSectionProps = {
  /** The section object. */
  section: AnalyticsSidenavSectionT;
  /** Whether the section is visually hidden. */
  hidden: boolean;
} & PropsWithChildren &
  PropsWithClassName;

export const AnalyticsSidenavSection = ({
  children,
  className,
  section,
  hidden = false,
}: AnalyticsSidenavSectionProps): JSX.Element => {
  const sectionClassName = classNames(
    styles.section,
    {
      [styles.sectionBordered]: section.bordered,
      [styles.sectionHidden]: hidden,
    },
    className,
  );

  return (
    <div className={sectionClassName} role="menu" aria-label={section.title}>
      {children}
    </div>
  );
};
